import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = {
  class: "modal-dialog modal-dialog-scrollable",
  style: {"max-width":"96%"}
}
const _hoisted_4 = {
  class: "modal-content",
  style: {"height":"calc(100vh - 5px)"}
}
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "modal-title" }

import $ from 'jquery'
    import { computed, watch, nextTick } from 'vue'

    import { KendoChart } from '@Kendo/Components/KendoChart'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'KendoChartFullScreenDialog',
  props: {
    propOpened: { type: Boolean },
    propTitle: {},
    propChart: {}
  },
  emits: ["close-dialog"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- computed ----------------

    const opened = computed(() => props.propOpened)
    const chart = computed(() => props.propChart ?? null)
    const title = computed(() => props.propTitle ?? '')

    // ---------------- watchers ----------------

    watch(opened, async (val) =>
    {
        if (!chart.value) return

        if (val === true)
        {
            await nextTick()

            $('#FullScreenChart').kendoChart(
                chart.value.GetOptions().Get()
            )

            chart.value.IsFullScreen = true
        }
        else
        {
            chart.value.IsFullScreen = false
        }
    })

    // ---------------- actions ----------------

    function close()
    {
        emit('close-dialog')
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h5", _hoisted_6, _toDisplayString(title.value), 1 /* TEXT */),
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "close"
                }, "×")
              ]),
              _cache[0] || (_cache[0] = _createElementVNode("div", {
                class: "modal-body",
                style: {"height":"100%"}
              }, [
                _createElementVNode("div", {
                  id: "FullScreenChart",
                  style: {"height":"100%"}
                })
              ], -1 /* CACHED */))
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})